/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export type Component = "oc-popover-v1";

export type Props = {
  /**
 *
 *
 *
 */
  variant?: `${OcPopoverVariant}`;

  /**
 *
 *
 *
 *
 *
 */
  sticky?: boolean;

  /**
 *
 *
 *
 *
 */
  visible?: boolean;

  /**
 *
 *
 *
 *
 *
 *
 *
 */
  anchor?: string | HTMLElement | "previous-sibling";

  /**
 *
 *
 *
 *
 *
 *
 */
  closeButton?: boolean;

  /**
 *
 *
 *
 */
  trigger?:
    | `${OcPopoverTrigger.NONE}`
    | `${OcPopoverTrigger.CLICK}`
    | `${OcPopoverTrigger.MOUSEENTER}`
    | `${OcPopoverTrigger.LONGPRESS}`
    | `${OcPopoverTrigger.FOCUS}`;

  /**
 *
 *
 *
 */
  closeOn?:
    | `${OcPopoverTrigger.NONE}`
    | `${OcPopoverTrigger.CLICK}`
    | `${OcPopoverTrigger.MOUSELEAVE}`
    | `${OcPopoverTrigger.BLUR}`;

  /**
 *
 *
 *
 */
  position?: "top" | "bottom";

  /**
 *
 *
 *
 */
  ocAriaLabel?: string;
};

export type Methods = {
  /**
 *
 *
 *
 */
  recalcPosition: () => void;
};

export type Events = {
  /**
 *
 *
 */
  "oc-popover-open": CustomEvent<void>;

  /**
 *
 *
 */
  "oc-popover-close": CustomEvent<void>;
};

export type Slots = {
  /**
 *
 *
 *
 *
 */
  default: string;
};

export type CssVariables = {
  /**
 *
 */
  "--background-color"?: string;

  /**
 *
 */
  "--padding"?: string;

  /**
 *
 */
  "--border-radius"?: string;

  /**
 *
 */
  "--min-width"?: string;

  /**
 *
 */
  "--max-width"?: string;

  /**
 *
 */
  "--arrow-height"?: string;
};

export enum OcPopoverTrigger {
  NONE = "none",
  CLICK = "click",
  LONGPRESS = "longpress",
  MOUSEENTER = "mouseenter",
  MOUSELEAVE = "mouseleave",
  FOCUS = "focus",
  BLUR = "blur",
}

export enum OcPopoverVariant {
  FLYOUT = "flyout",
  TOGGLETIP = "toggletip",
  TOOLTIP = "tooltip",
}
